"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockedLocalizedDictionary = exports.MockedLocalized = void 0;
var React = __importStar(require("react"));
var util_1 = require("./util");
var MockedLocalized = /** @class */ (function (_super) {
    __extends(MockedLocalized, _super);
    function MockedLocalized() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MockedLocalized.prototype.render = function () {
        var _a = this.props, defaultValue = _a.defaultValue, variables = _a.variables, children = _a.children;
        var derivedVariables = variables || (0, util_1.extractVariables)(children);
        if (children instanceof Function) {
            var derivedDefaultValue_1 = defaultValue || '<no default value>';
            var translation = Object.keys(derivedVariables).length > 0
                ? "".concat(derivedDefaultValue_1, " (").concat(JSON.stringify(derivedVariables), ")")
                : derivedDefaultValue_1;
            return children(translation);
        }
        var derivedDefaultValue = defaultValue || extractMockDefaultValue(children);
        return Object.keys(derivedVariables).length > 0 ? (React.createElement(React.Fragment, null,
            derivedDefaultValue,
            " (",
            JSON.stringify(derivedVariables),
            ")")) : (derivedDefaultValue);
    };
    MockedLocalized.displayName = 'Localized';
    return MockedLocalized;
}(React.Component));
exports.MockedLocalized = MockedLocalized;
var MockedLocalizedDictionary = /** @class */ (function (_super) {
    __extends(MockedLocalizedDictionary, _super);
    function MockedLocalizedDictionary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MockedLocalizedDictionary.prototype.render = function () {
        var _a = this.props, idsAndDefaultValues = _a.idsAndDefaultValues, variables = _a.variables, children = _a.children;
        if (children === undefined) {
            return null;
        }
        var results = Object.keys(idsAndDefaultValues).reduce(function (memo, key) {
            var _a;
            return (__assign(__assign({}, memo), (_a = {}, _a[key] = variables !== undefined
                ? "".concat(idsAndDefaultValues[key], " (").concat(JSON.stringify(variables), ")")
                : idsAndDefaultValues[key], _a)));
        }, {});
        return children(results);
    };
    MockedLocalizedDictionary.displayName = 'LocalizedDictionary';
    return MockedLocalizedDictionary;
}(React.Component));
exports.MockedLocalizedDictionary = MockedLocalizedDictionary;
var extractMockDefaultValue = function (nodes) {
    if (nodes === undefined) {
        return '';
    }
    if (typeof nodes === 'string' || typeof nodes === 'number' || typeof nodes === 'boolean') {
        return nodes.toString();
    }
    if (React.isValidElement(nodes)) {
        // No children, just clone the element itself
        if (!nodes.props.children) {
            return React.cloneElement(nodes);
        }
        return React.cloneElement(nodes, { children: extractMockDefaultValue(nodes.props.children) });
    }
    if (nodes instanceof Array) {
        return nodes.map(function (node, idx) { return React.createElement(React.Fragment, { key: idx }, extractMockDefaultValue(node)); });
    }
    if (typeof nodes === 'object') {
        return "{{ ".concat(Object.keys(nodes).join(' '), " }}");
    }
    return '';
};
